import { useBeam } from "@randajan/bifrost/client/react";
import { meBeam } from "../../assets/beams/meBeam";
import { legalsBeam } from "../../assets/beams/legalBeam";
import { usePop } from "@randajan/jet-react/dom/modal";
import { LegalsWizard } from "./LegalsWizard/LegalsWizard";
import { validateLegalSigns } from "../../../arc/game/events";
import { useCallback } from "react";




export const useLegalsCheck = (onPass=()=>{}, reqLegalsPaths = []) => {
    const { data: user } = useBeam(meBeam);
    const { data: legals } = useBeam(legalsBeam);

    const pop = usePop({ lock: true });

    return useCallback(async _=> {
        if (!user || !legals) { return; }

        const { isMissing, requiredList } = await validateLegalSigns(legals, f => user[f], reqLegalsPaths);

        if (!isMissing) {
            pop.down();
            onPass();
        } else {
            pop.up({
                children: <LegalsWizard requiredList={requiredList} />,
                onDown: (_, result) => {
                    if (result) { onPass(result); }
                }
            });
        }

    }, [user, legals, pop]);
}